import React, { useEffect, useRef, useState } from "react";
import VideoManager from "../VideoV2/Manager";
import { IMedium } from "../../store/VideoStore";
interface IUseVideoCore {
  list: IMedium[];
  index: number;
  mode: string;
  forceNoAutoPlay?: boolean;
}

export default function (props: IUseVideoCore) {
  const bigVideoWrapper = useRef<HTMLDivElement>(
    window.document.createElement("div")
  );
  bigVideoWrapper.current.className = "big-video-portal bigpic";
  const { index, list, mode, forceNoAutoPlay } = props;
  const [init, setInit] = useState(false);
  const setCurrentVideoAutoPlay = () => {
    if (index > -1) {
      let source = list[index];
      if (source && source.id) {
        let instance = VideoManager.getPlayerInstance(`bigvideo_${source.id}`);
        if (instance) {
          if (!forceNoAutoPlay) {
            console.log(`开启播放`, source.id);
            instance.play();
          }

          setInit(true);
        }
      }
    }
  };

  const onCreated = (id: string) => {
    if (init) {
      return;
    }

    setInit(true);
    console.log(`auto play onCreated`, init);
    setCurrentVideoAutoPlay();
  };

  useEffect(() => {
    if (index > -1) {
      setCurrentVideoAutoPlay();
    }
  }, [index]);

  useEffect(() => {
    if (!bigVideoWrapper.current?.parentNode) {
      window.document.body.appendChild(bigVideoWrapper.current);
    }

    return () => {
      if (bigVideoWrapper.current?.parentNode) {
        window.document.body.removeChild(bigVideoWrapper.current);
      }
    };
  }, []);

  const [size, setSize] = useState({
    width: 0,
    height: 0,
  } as {
    width: number;
    height: number;
    percent?: number;
  });

  useEffect(() => {
    if (bigVideoWrapper.current?.parentNode) {
      if (mode == "h") {
        let width = bigVideoWrapper.current.clientWidth;
        let height = Math.min(
          window.innerHeight,
          Math.round((width / 16) * 9) + 44
        );

        setSize({
          width,
          height,
        });
      }
      else if (mode == "v") {
        let height = bigVideoWrapper.current.clientHeight;
        let width = Math.min(
          bigVideoWrapper.current.clientWidth,
          (height / 16) * 9
        );
        height = Math.min(window.innerHeight, Math.round((width / 9) * 16));

        setSize({
          width,
          height,
        });
      }else {
        setSize({
          width:bigVideoWrapper.current.clientWidth,
          height:bigVideoWrapper.current.clientHeight - 40
        })
      }
    }
  }, [bigVideoWrapper.current?.parentNode]);

  return {
    onCreated,
    bigVideoWrapper: bigVideoWrapper.current,
    size,
  };
}
